// removed by extract-text-webpack-plugin
module.exports = {"container":"cnqQz8sp0hJhn2q5a8xV"};